import "./src/styles/global.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AOS from "aos";
import "aos/dist/aos.css";
import type { GatsbyBrowser } from "gatsby";
import { trackRouteChange } from "./src/lib/tracking";

export const onClientEntry = () => {
  AOS.init({
    disable: "mobile",
  });
};

export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = ({ location }) => {
  trackRouteChange(location);
};
